/**
 * CANDIDATE COPY, not approved: awaiting Charles's approval before merge (verifime-adr#617).
 *
 * Every string RequestIdentityCard shows by default. A string marked CANDIDATE is new copy.
 * An unmarked string is reused as built. The caller can replace any of them through props.
 */

export const REQUEST_IDENTITY_CARD_COPY = {
  // As built: the identity status words in Identities/types.ts (Verified, Draft).
  verified: 'Verified',
  draft: 'Draft',
  submitted: 'Submitted', // CANDIDATE COPY, not approved (verifime-adr#617)
  shared: 'Already shared', // CANDIDATE COPY, not approved (verifime-adr#617)
  selected: 'Selected', // CANDIDATE COPY, not approved (verifime-adr#617)
} as const;
